module.exports = __webpack_public_path__ + "img/kedatianxia.a3091833.png";